import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'my-work',
  template: require('./work.component.html'),
  styles: [require('./work.component.scss')]
})
export class WorkComponent implements OnInit {
  private experience = [
  { position: 'Co-Founder/CTO',
    company: '<a href="https://peakresponse.net/">Peak Response</a>',
    dates: 'January 2020  –  Present',
    description: 'Peak Response aims to improve the accuracy and efficiency of triage management during mass casualty incidents. Formerly NaT/NaTriage, category winner and best in show at the 2019 regional Tech to Protect Challenge in San Francisco, award of excellence and seed grant recipient at the 2020 national Tech to Protect Challenge.' },
  { position: 'Board Member',
    company: '<a href="https://devmission.org/">Dev/Mission</a>',
    dates: 'June 2018  –  Present',
    description: 'We aim to train untapped young adults ages 16-24 for careers in technology; so we can build wealth and prosperity in our local diverse communities.' },
  { position: 'Co-Founder',
    company: '<a href="https://www.passionforcoding.org/">Passion for Coding</a>',
    dates: 'January 2018  –  Present',
    description: 'Passion for Coding is a community of volunteer software engineers who run 1 hour, in-person, hands-on coding workshops in elementary school classrooms designed to inspire the next generation to be masters of technology rather than simply consumers.' },
  { position: 'Co-Founder/CTO',
    company: '<a href="https://www.dohje.com/">DohJe</a>',
    dates: 'May 2013  –  June 2019 (6 years 2 months)',
    description: 'The mission of DohJe is to improve healthcare through gratitude. DohJe means &quot;Thank You&quot; in Cantonese.<br><br>DohJe HELPS PATIENTS AND FAMILIES<br>Caregivers earn our gratitude by seeing us through the most significant moments in our lives. While some people think to say &quot;thanks&quot; in the moment, many people carry around unexpressed gratitude for months or years. DohJe makes it easy for patients to say &#x201C;thank you&#x201D; anytime, from anywhere. <br><br>DohJe HELPS CAREGIVERS<br>DohJe is a tool for caregivers to directly receive, respond to, and store inspirational notes and photos online.<br><br>DohJe HELPS HEALTH CARE FACILITIES<br>Using DohJe raises staff morale, reduces attrition, and provides new insights on performance that goes beyond traditional surveys.' },
  { position: 'VP UX Technology',
    company: 'Wrap Media',
    dates: 'January 2015  –  April 2017 (2 years 4 months)',
    description: 'Wrap is a mobile-first marketing and commerce platform that provides a beautiful world of storytelling in bite-size moments that get and hold attention.' },
  { position: 'Co-Founder/CTO',
    company: 'Bitlogica inc.',
    dates: 'May 2014  –  January 2015 (9 months)',
    description: 'Bitlogica is a boutique high tech venture accelerator based in Silicon Valley. <br><br>We are a group of visionary and creative engineers, designers, leaders and CTOs with a deep experience scaling companies and resolving hard problems. <br><br>We just make stuff happen much faster. <br><br>http://www.bitlogica.com' },
  { position: 'Consultant',
    company: 'Self-Employed',
    dates: 'January 2012  –  May 2014 (2 years 5 months)',
    description: null },
  { position: 'Co-Founder/CTO',
    company: 'Yiip, Inc',
    dates: 'July 2011  –  December 2011 (6 months)',
    description: 'Adapted the AUDIOPRESS platform for Yiip, a social voice messaging application.' },
  { position: 'Co-Founder/CTO',
    company: 'AudioPress',
    dates: 'September 2009  –  December 2011 (2 years 4 months)',
    description: 'Managed both product design and engineering of the AUDIOPRESS application, service, and platform. Was hands-on in both interaction design and software architecture/development across mobile/embedded and server platforms. AUDIOPRESS was featured by Apple in Top Trends in News apps for iTunes Rewind 2010.' },
  { position: 'VP of Product',
    company: 'Tiny Pictures, Inc.',
    dates: 'February 2008  –  February 2009 (1 year 1 month)',
    description: 'Vice President of Product Design and Development<br>http://radar.net/<br>http://www.tinypictures.us/' },
  { position: 'Director of Mobile',
    company: 'Tiny Pictures, Inc.',
    dates: 'February 2007  –  February 2008 (1 year 1 month)',
    description: 'http://www.radar.net/<br>http://www.tinypictures.us/' },
  { position: 'Sr. Mobile Developer',
    company: 'Tiny Pictures',
    dates: 'January 2006  –  January 2007 (1 year 1 month)',
    description: 'http://www.radar.net/<br>http://www.tinypictures.us/' },
  { position: 'Software Engineer',
    company: 'Glu Mobile',
    dates: 'December 2003  –  December 2005 (2 years 1 month)',
    description: 'http://www.glu.com/<br>http://www.francisli.com/ecko/<br>http://www.francisli.com/dailypuzzle/<br>http://www.francisli.com/fsm/<br><br>Lead developer of Java 2 Micro Edition games and information service client applications, contributer to concept development and user interface design, prototyping, and evaluation. Directly handled as well as supervised porting responsibilities across handsets and carriers.' },
  { position: 'Designer Intern',
    company: 'iconmobile',
    dates: 'July 2002  –  September 2002 (3 months)',
    description: 'http://www.iconmobile.com/<br>http://www.metadesign.de/<br>http://francisli.com/iconmobile/<br><br>Assisted in the prototyping and development of new services for mobile phones and wireless networks, including designing for the i-Mode platform and location-based network, next generation handsets, and the Java 2 Micro Edition application platform.' },
  { position: 'Researcher Intern',
    company: 'Sun Microsystems Laboratories',
    dates: 'May 2000  –  August 2000 (4 months)',
    description: 'http://research.sun.com/<br><br>Assisted in the design and development of Awarenex, a system that provides awareness information for initiating communication between users of mobile and desktop computing and communication devices.' },
  { position: 'Researcher Intern',
    company: 'Microsoft Research',
    dates: 'January 1999  –  August 1999 (8 months)',
    description: 'http://research.microsoft.com/<br><br>Assisted in the development and evaluation of the Microsoft Research Annotation System (MRAS). Also the principal investigator in the design and evaluation of software for browsing and skimming digital video.' }
  ];
  private education = [
  { school: 'Interaction Design Institute Ivrea',
    degree: 'Master, Interaction Design',
    dates: '2001  –  2003' },
  { school: 'University of California, Berkeley',
    degree: 'MS, Computer Science',
    dates: '1999  –  2001' },
  { school: 'University of California, Berkeley',
    degree: 'BA, Computer Science',
    dates: '1996  –  1998' }
  ];

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/work/work.component.ts